import type { BudgetPhaseForm } from "./BudgetSelector";

/** Minimum scheduled phases is 2; only index 2+ (the 3rd phase onward) may be removed. */
export const SCHEDULED_BUDGET_FIRST_DELETABLE_PHASE_INDEX = 2;

export function sumPhaseAmounts(segments: BudgetPhaseForm[]): number {
  return segments.reduce((sum, s) => {
    const raw = s.amount?.amount;
    if (raw == null || raw === ("" as never)) return sum;
    const n = typeof raw === "number" ? raw : parseFloat(String(raw));
    return sum + (Number.isFinite(n) ? n : 0);
  }, 0);
}

/** Two decimals, no thousands separator (display). */
export function formatBudgetTwoDecimals(value: number): string {
  if (!Number.isFinite(value)) return "0.00";
  return value.toFixed(2);
}
